module.exports = __webpack_public_path__ + "img/img20.a2eb26d8.png";